<template>
  <v-row no-gutters class="fill-height flex-column" style="overflow-y: auto; overflow-x: hidden;">
    <v-col cols="12" class="pr-6">
      <card-title-row :straightTitle="$i18n.t('sidebar.scadaAlarms.title')" class="pt-5" />
      <template v-if="alarmsUnconfirmed.length">
        <v-row no-gutters>
          <v-col cols="auto">
            <v-badge
              overlap
              :content="alarmsUnconfirmedCount"
              :value="alarmsUnconfirmedCount"
              color="error"
              :offset-x="28"
            >
              <card-title-row is-subtitle :straightTitle="$i18n.t('sidebar.scadaAlarms.activeUnconfirmed')" />
            </v-badge>
          </v-col>
        </v-row>
        <sidebar-row>
          <expandable-list :items="alarmsUnconfirmed" @zoom="zoom($event, 'unconfirmed')" />
        </sidebar-row>
      </template>
      <template v-if="alarmsConfirmed.length">
        <v-row no-gutters :class="{ 'pt-5': alarmsUnconfirmed.length }">
          <v-col cols="auto">
            <v-badge overlap :content="alarmsConfirmedCount" :value="alarmsConfirmedCount" color="edit" :offset-x="28">
              <card-title-row is-subtitle :straightTitle="$i18n.t('sidebar.scadaAlarms.activeConfirmed')" />
            </v-badge>
          </v-col>
        </v-row>
        <sidebar-row>
          <expandable-list :items="alarmsConfirmed" @zoom="zoom($event, 'confirmed')" />
        </sidebar-row>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';

import CardTitleRow from '@/components/CardTitleRow';
import ExpandableList from '@/components/ExpandableList';
import SidebarRow from '@/components/SidebarRow';

export default {
  name: 'Alarms',
  components: { CardTitleRow, ExpandableList, SidebarRow },
  computed: {
    alarms: get('alarms/alarms'),
    alarmsConfirmed() {
      return this.alarms.alarms.data.map(alarm => {
        const { name: title, count } = alarm;
        return {
          title,
          subtitle: `${this.$i18n.t('sidebar.scadaAlarms.alarmsCount')}: ${count}`,
          icons: [{ name: 'zoom', vText: 'mdi-magnify', size: 18, color: 'primary' }],
        };
      });
    },
    alarmsUnconfirmed() {
      return this.alarms.unconfirmed_alarms.data.map(alarm => {
        const { name: title, count } = alarm;
        return {
          title,
          subtitle: `${this.$i18n.t('sidebar.scadaAlarms.alarmsCount')}: ${count}`,
          icons: [{ name: 'zoom', vText: 'mdi-magnify', size: 18, color: 'primary' }],
          appendOuterIcon: `${process.env.VUE_APP_API_URL}/icons/closed.svg`,
        };
      });
    },
    alarmsConfirmedCount() {
      return this.alarms.alarms.total_count || 0;
    },
    alarmsUnconfirmedCount() {
      return this.alarms.unconfirmed_alarms.total_count || 0;
    },
  },
  methods: {
    zoom(element, type) {
      const geometry = this.alarms[type === 'confirmed' ? 'alarms' : 'unconfirmed_alarms']?.data[element.idx]?.geometry;
      if (geometry) {
        this.$root.$emit('createGeomAndFitView', geometry);
      }
    },
  },
};
</script>
